module.exports = __webpack_public_path__ + "media/signup-react/purpurle-oval-94123da3.png";